import { render, staticRenderFns } from "./FoldSwitch.vue?vue&type=template&id=26a42b6c&scoped=true"
import script from "./FoldSwitch.vue?vue&type=script&lang=js"
export * from "./FoldSwitch.vue?vue&type=script&lang=js"
import style0 from "./FoldSwitch.vue?vue&type=style&index=0&id=26a42b6c&prod&lang=scss&scoped=true"
import style1 from "./FoldSwitch.vue?vue&type=style&index=1&id=26a42b6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a42b6c",
  null
  
)

export default component.exports